import SoundManager from "../../../../../lib/html5-software-library/src/ranj/audio/SoundManager";
import Slice9Panel from "../../../../../lib/html5-software-library/src/ranj/components/scale9/Slice9Panel";
import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import LayoutManager from "../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import ClickEaterFactory from "../../../core/ui/ClickEaterFactory";
import ScenarioLibrary from "../../../ngt/scenario/ScenarioLibrary";
import DebugModel from "../../debug/model/DebugModel";
import SaveGameEvent from "../../savegame/event/SaveGameEvent";
import SaveGameModel from "../../savegame/model/SaveGameModel";
import MovieClipUtil from "../../util/MovieClipUtil";
import PromiseUtil from "../../util/PromiseUtil";
import LoadingScreenEvent from "../event/LoadingScreenEvent";

export default class LoadingScreenMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {ClickEaterFactory} clickEaterFactory 
     * @param {RevisableLanguagePack} languagePack 
     * @param {SoundManager} soundManager 
     * @param {ScenarioLibrary} scenarioLibrary 
     * @param {SaveGameModel} saveGameModel 
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, languagePack, soundManager, scenarioLibrary, saveGameModel) {
        super(target, dispatcher, layoutManager, clickEaterFactory);

        this._languagePack = languagePack;
        this._soundManager = soundManager;
        this._scenarioLibrary = scenarioLibrary;
        this._saveGameModel = saveGameModel;
    }

    initialize() {
        super.initialize();

        this.preventClickThrough();

        this._currentScenario = this._scenarioLibrary.getCurrentScenario();

        this._slicedLoadingPanel = new Slice9Panel(this._target.loadingPanel, MovieClipUtil.getFirstBitmapChild(this._target.loadingPanel), {
            mode: Slice9Panel.HORIZONTAL,
            pixelPerfect: true,
            overlap: false,
        });

        this._target.loadingPanel.textField.text = this._languagePack.getText(`loading.loadingText`);
        this._slicedLoadingPanel.update();

        this._target.progressionPath.gotoAndStop(this._currentScenario?.id ?? 0);
        this._showSequence();

    }

    async _showSequence() {
        this._target.loadingPanel.alpha = 0;

        const transitionTime = 650;
        await PromiseUtil.delay(transitionTime + 1000); // Account for transition time.
        await MovieClipUtil.gotoAndPlayUntilPause(this._target.progressionPath, this._currentScenario?.id ?? 0);
        await PromiseUtil.delay(DebugModel.fasterAnimations ? 150 : 2000);

        // Show pending game saved feedback if any.
        if (this._saveGameModel.gameSavedFeedbackPending) {
            this.dispatch(SaveGameEvent.SHOW_PENDING_FEEDBACK);
            await PromiseUtil.delay(DebugModel.fasterAnimations ? 150 : 2000);
        }

        createjs.Tween.get(this._target.loadingPanel)
            .to({ alpha: 1 }, 650, createjs.Ease.sineInOut);

        this.dispatch(LoadingScreenEvent.LOADING_ANIMATION_FINISHED);
    }
}